import { createSlice } from "@reduxjs/toolkit";

// const sipServer = process.env.REACT_APP_VOIP_SERVER_BASE_URL;
const webSocketUrl = process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL;

const initialState = {
  sipUsername: "",
  sipPassword: "",
  // sipServer: sipServer,
  sipServer: "",
  webSocketUrl: webSocketUrl,
};

const SIPConfigSlice = createSlice({
  name: "SIPConfig",
  initialState,
  reducers: {
    updateSipConfig: (state, action) => {
      state.sipUsername = action?.payload?.sipUsername;
      state.sipPassword = action?.payload?.sipPassword;
      // state.sipServer = action?.payload?.sipServer || sipServer;
      state.sipServer = action?.payload?.sipServer;
      state.webSocketUrl = action?.payload?.webSocketUrl || webSocketUrl;
    },

    removeSipConfig: (state) => {
      state.sipUsername = "";
      state.sipPassword = "";
      state.sipServer = "";
    },
  },
});

export const { updateSipConfig, removeSipConfig } = SIPConfigSlice.actions;

export default SIPConfigSlice.reducer;
